


document.addEventListener("DOMContentLoaded", function(){


  const swiper = new Swiper('.blogTypeSwiper', {
  // Optional parameters
        slidesPerView: 1,
        spaceBetween: 10,
        loop: false,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 10,
          },
        }

});

  
//   var isMobile = {
//     Android: function() {
//         return navigator.userAgent.match(/Android/i);
//     },
//     BlackBerry: function() {
//         return navigator.userAgent.match(/BlackBerry/i);
//     },
//     iOS: function() {
//         return navigator.userAgent.match(/iPhone|iPad|iPod/i);
//     },
//     Opera: function() {
//         return navigator.userAgent.match(/Opera Mini/i);
//     },
//     Windows: function() {
//         return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
//     },
//     any: function() {
//         return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
//     }
// };


//   if( isMobile.any() ) alert('Mobile');

//   if( isMobile.iOS() ) alert('iOS');

//     if( isMobile.Android() ) alert('iOS');
  

  
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/windows phone/i.test(userAgent)) { document.querySelector('html').classList.add('windows'); }
    else if (/android/i.test(userAgent)) { document.querySelector('html').classList.add('android'); }
    else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) { document.querySelector('html').classList.add('ios'); }


  
     if (document.querySelector('.ecom-product-single__swatch-select')) {


       
        const currency = window.ShopifyAnalytics.meta.currency;
        console.log(window.ShopifyAnalytics.meta);
        console.log(currency);
       
    
       //   console.log(priceSale);
        var delayInMilliseconds = 1000; //1 second

        setTimeout(function() {
               const moneySale = document.querySelector('.ecom-product-single__price--sale .money');
               const moneyReg = document.querySelector('.ecom-product-single__price--regular .money');
               
               const priceReg = moneyReg.textContent;
               const priceSale = moneySale.textContent;
              document.querySelector('.ecom-product-single__add-to-cart--submit').disabled = true;
             let btn = document.querySelector('.ecom-product-single__add-to-cart--submit');
             btn.classList.add("selectSize");
             const select = document.querySelector('.ecom-product-single__swatch-select');
             const options = select.querySelectorAll('option');
             if (options.length > 1) {
                let option = new Option('Select your size');
          
                select.add(option, select.firstChild);
                select.selectedIndex = 0;
              }

                document.querySelector('.ecom-product-single__swatch-select').addEventListener('change', function() {
                  if (this.value == 'Select your size') {
                      console.log('You selected default: ', this.value);
                     const elements = document.querySelectorAll('.money');
                    elements.forEach(el => {
                      el.textContent = priceSale;
                    });
                    let btnBuy = document.querySelector('.ecom-product-single__add-to-cart--submit');
                    let textBtn = document.querySelector('.ecom-add-to-cart-text');
                    textBtn.textContent = 'ADD TO CART';
                    btnBuy.classList.add("selectSize");
                
                  } else {
                    console.log('You selected: ', this.value);
                    let btnBuy = document.querySelector('.ecom-product-single__add-to-cart--submit');
                    let textBtn = document.querySelector('.ecom-add-to-cart-text');
                    if (btnBuy.classList.contains("selectSize")) {
                      btnBuy.classList.remove("selectSize");
                    }
                  }
        
                });
        }, delayInMilliseconds);
      

       // let textBtnOut = document.querySelector('.ecom-add-to-cart-text');
       //  textBtnOut.textContent = 'ADD TO CART';
       //  textBtnOut.classList.add("selectSize");
       //   let btn = document.querySelector('.ecom-product-single__add-to-cart--submit');
       //   btn.classList.add("selectSize");

       //  document.querySelector('.ecom-product-single__swatch-select').addEventListener('change', function() {
       //    if (this.value == 'Select your size') {
       //        console.log('You selected default: ', this.value);
       //       const elements = document.querySelectorAll('.money');
       //      elements.forEach(el => {
       //        el.textContent = priceSale;
       //      });
       //      let btnBuy = document.querySelector('.ecom-product-single__add-to-cart--submit');
       //      let textBtn = document.querySelector('.ecom-add-to-cart-text');
       //      textBtn.textContent = 'ADD TO CART';
       //      btnBuy.classList.add("selectSize");
        
       //    } else {
       //      console.log('You selected: ', this.value);
       //      let btnBuy = document.querySelector('.ecom-product-single__add-to-cart--submit');
       //      let textBtn = document.querySelector('.ecom-add-to-cart-text');
       //      if (btnBuy.classList.contains("selectSize")) {
       //        btnBuy.classList.remove("selectSize");
       //      }
       //    }

       //  });
      

     }
   
Fancybox.bind("[data-fancybox]", {
  Toolbar: {
    display: [
      {
        id: "counter",
        position: "center",
      },
      "zoom",
      "slideshow",
      "fullscreen",
      "thumbs",
      "close",
    ],
  },
});
  
});